module.exports = __webpack_public_path__ + "img/108.9ea4861a.gif";